<template>
  <div class="page-CommuniCation">
    <div class="word">
      <el-image :src="url1"></el-image>
    </div>
    <div style="height:30px"></div>
    <PageTemplate>
      <div class="in-content-warpper">
        <div class="row">
          <div class="des">
            <div class="title">
              联系我们
            </div>
            <el-row style="height:30px"></el-row>
            <p>地址：广州市天河区高普路138号京华信息大楼东座203、204单元</p>
            <el-row style="height:10px"></el-row>
            <p>电话：（+86）020-85167887</p>
            <p>传真：（+86）020-85167887</p>
          </div>
        </div>
      </div>
    </PageTemplate>
    <el-row style="height:200px"></el-row>
    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '@/components/Footer'
import PageTemplate from '@/components/PageTemplate'
export default {
  components:{Footer, PageTemplate},
  data () {
    return {
      url1: require('../assets/FZdbPJxr.jpg')
    }
  },
  created () {
  },
  methods : {
  }
}
</script>
<style scoped lang="scss">
.page-CommuniCation{
  background-color: rgb(243, 242, 242);
  .word{
    width: 100%;
    height: 300px;
    .el-image {
      width: 100%;
      height: 300px;
    }
  }
  .in-content-warpper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: #ffffff;
    .row {
      width: 100%;
      height: 500px;
      display: flex;
      flex-direction: row;
      justify-content:space-between;
      align-items: center;
      .img {
        width: 500px;
        height: 340px;
        .el-image {
          width: 500px;
          height: 340px;
        }
      }
      .des {
        width: 600px;
        text-align: left;
        margin-left: 100px;
        padding-top: 1;
        line-height: 1.2;
        .title{
          font-size: 25px;
          font-weight: 600;
          color: #000;
        }
      }
    }
  }
}
    
</style>



// WEBPACK FOOTER //
// src/views/CommuniCation.vue